module.exports = __webpack_public_path__ + "static/celine_portrait-64aaa4e5f442064645b99b3a796ab87f.jpg";